/* common ajax method define  */
import {i18n} from './i18n'
import config from '../config'
import { alert, toast, loading } from './common'

/**
 * 微信小程序相关请求专用的网络接口，去除了自动跳转h5相关页面的逻辑
 * @param {*} options 配置信息同ajax.js中的options
 */
export default function wxajax (options) {
  const props = {
    credentials: 'include',
    method: options.method || 'GET'
  }

  const headers = {
    'Content-Type': options.contentType || 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }

  if (config.csrf_token) {
    headers['requesttoken'] = config.csrf_token
  }
  if (config.auth_token) {
    headers['Auth-Token'] = config.auth_token
  }

  if (options.headers) {
    Object.assign(headers, options.headers)
  }
  props.headers = headers

  if (options.data) {
    props.method = 'post'
    props.body = options.formData ? options.data : JSON.stringify(options.data)
  }

  // const url = options.url.indexOf('?') > -1 ? `${options.url}&_=${+new Date()}` : `${options.url}?_=${+new Date()}` //fix ie cache
  const urlPrefix = options.urlPrefix || config.apiUrl
  // global loading

  // options.loading: true or loading text, if true, use default '加载中'
  let ld
  if (options.loading) {
    ld = loading(typeof options.loading === 'string' ? options.loading : undefined)
  }
  return fetch(urlPrefix + options.url, props).then(response => {
    // console.log(response)
    if (response.status === 500) {
      alert({
        title: i18n.t('base.alert.server500.title'),
        message: i18n.t('base.alert.server500.content')
      })
    } else if (response.status === 502) {
      alert(i18n.t('base.alert.server502'))
    } else if (response.status === 504) {
      alert(i18n.t('base.alert.server504'))
    } else if (response.status === 404) {
      alert(i18n.t('base.alert.server404'))
    } else if (response.status === 403) {
      alert(i18n.t('base.alert.server403'))
    } else if (response.status === 401) {
      alert('认证信息过期')
    } else {
      ld && ld.clear()
      return response.json()
    }
    // resolve confirm promise when fail to fetch
    if (options.resolve) {
      options.resolve(false)
    }
  }).then(result => {
    if (!result) return false
    // toast
    if (result.success && options.successMessage) {
      toast.success(options.successMessage)
    }
    // 回传参数
    result.requestQuery = options.requestQuery
    // resolve confirm promise
    if (options.resolve) {
      options.resolve(result.success)
    }
    if (result.success || (options.accept_all_errors && result.errors) || (options.accept_errors && result.errors && Object.keys(result.errors).some(err => options.accept_errors.indexOf(err) > -1))) {
      if (options.parser) {
        result = options.parser(result)
      }
      return result
    }

    result.success = true
    if (result.errors) {
      result.success = false
      const errors = result.errors
      if (errors.validation_errors || errors.external_errors) {
        var errs = errors.validation_errors || errors.external_errors
        alert(errs[0].error_tr_msg).then(() => {
          options.errorCallBack && options.errorCallBack()
        })
      } else if (errors.permission_denied) {
        // console.log(errors)
        alert(i18n.t('base.noPermission')).then(() => {
          options.errorCallBack && options.errorCallBack()
          if (result.redirect) {
            // window.location.href = result.redirect;
          }
        })
      }
    } else if (result.error) { // 移动端有些api会以这种格式返回报错信息
      result.success = false
      alert({
        message: result.message
      }).then(() => {
        options.errorCallBack()
      })
    }

    return result
  }).catch(e => {
    if (!options.skipNetworkError) {
      if (e.toString() === 'TypeError: Failed to fetch') {
        alert(i18n.t('base.failToFetch'))
      } else if (e.toString() === 'TypeError: NetworkError when attempting to fetch resource.') {
        // 火狐未请求完成，不再弹窗
      } else {
        alert(e.toString())
      }
    } else {
      if (e) {
        e.fetchError = true
      }
      throw e
    }
    // eslint-disable-next-line
    console.error(e);
  })
}
